import { render, staticRenderFns } from "./feedA.vue?vue&type=template&id=5ea64e64&scoped=true"
import script from "./feedA.vue?vue&type=script&lang=js"
export * from "./feedA.vue?vue&type=script&lang=js"
import style0 from "./feedA.vue?vue&type=style&index=0&id=5ea64e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea64e64",
  null
  
)

export default component.exports